import { get, ref } from "firebase/database";
import { CashMovementData, CashMovementRecord } from "../../models/cashMovement";
import { db } from "../firebaseConfig";

export const getCashMovementsByDateRange = async (
	startDate: string,
	endDate: string
): Promise<CashMovementRecord[]> => {
	const cashMovementsRef = ref(db, "cashMovements");
	const snapshot = await get(cashMovementsRef);

	if (!snapshot.exists()) {
		return [];
	}

	const movements = snapshot.val() as Record<string, CashMovementData>;
	return Object.entries(movements)
		.map(([id, movement]) => ({ id, ...movement }))
		.filter((movement) => {
			const movementDate = movement.movementDate.substring(0, 10);
			return movementDate >= startDate && movementDate <= endDate;
		});
};
